import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import PayPage from "@/pages/PayPage";
import PaymentCallback from "@/pages/PaymentCallback";
import PrivacyPage from "@/pages/PrivacyPage";
import DemoPage from "@/pages/DemoPage";
import SupportWidget from "@/components/SupportWidget";

function Shell({ children }) {
  const location = useLocation();
  // Detect OAuth callback synchronously during render to avoid races.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      {children}
      <footer className="border-t border-slate-200 bg-white mt-12">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <span>© 2026 زبطنا — Zabatna</span>
          <div className="flex items-center gap-4">
            <a href="/demo" className="hover:text-slate-900" data-testid="footer-demo-link">{`عيّنة`}</a>
            <a href="/privacy" className="hover:text-slate-900" data-testid="footer-privacy-link">{`سياسة الخصوصية`}</a>
          </div>
        </div>
      </footer>
      <SupportWidget />
    </>
  );
}

function AppRoutes() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/pay/:orderId" element={<ProtectedRoute><PayPage /></ProtectedRoute>} />
        <Route path="/payments/moyasar/callback" element={<ProtectedRoute><PaymentCallback /></ProtectedRoute>} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
